/**
 * Generates a random ID
 * @param {string} [prefix]
 * @return {string}
 */
export function generateId(prefix: string = 'input_') : string {
    return prefix + (Math.random() + 1).toString(36).substring(2);
}

/**
 * Runs the given function at the start of the next render frame.
 * @param {function} callback
 * @return {void}
 */
export function onNextFrame(callback : () => any) : void {
    requestAnimationFrame(() =>
        requestAnimationFrame(callback)
    );
}

/**
 * Resolves when the next render frame is started.
 * @return {Promise<void>}
 */
export function nextFrame() : Promise<void> {
    return new Promise(resolve => onNextFrame(resolve));
}

/**
 * Resolves after a given delay
 * @param {number} ms
 * @return {Promise<void>}
 */
export function delay(ms: number) : Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Returns whether the attribute value is true, false, or neither.
 * @param {string|number|boolean} value
 * @returns {undefined|boolean}
 */
export function getBoolFromAttribute(value: string|number|boolean) : boolean {
    if (value === '1' || value === 'true' || value === 'on' || value === true || value === 1) return true;
    if (value === '0' || value === 'false' || value === 'off' || value === false || value === 0) return false;
    return undefined;
}

export function scrollTo(element : HTMLElement) : void {
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

